import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { MatchSRA } from 'helpers/Validation';
import OnlineOfflineIndicator from './OnlineOflineSection';
import { FooterContainer, GradientLine, FooterContent, TrfDropdown, SubmitButton, Version, OpenCameraButton, CloseCameraButton, ModifyButton } from './Footer.styled';
import TrfDropdownSelection from './TrfDropdownSelect';
import TimerIcon from '@material-ui/icons/Timer';
import { NONMO_USER_ROLE } from 'journeys/portal/Home/Home.constants';

const LOGGED_IN_AS_TEXT = 'User Logged in as ';

const Footer = (props) => {
    const { handleButton, headerText, isDisabled, userRole, adGroupType, displayFormStatus,
        isMRATOnline, trfSelectionVisible, buttonVisible, buttonText, widerFooter, draftButtonVisible,
        openCameraButtonVisible, openCameraHandler, closeCameraButtonVisible, closeCameraHandler,
        currentAppView, printButtonVisible, printButtonHandler, draftButtonHandler, draftStatus, draftNoteVisible,
        selectedRowTags, footerNoteMoVisible, selectedTag, draftDuration, entryButtonVisible, modifyButtons, selectedTrfId, nonMoTagDuration, GetNonMoTrfList, IsLateEntry } = props;
    const isPageHomeScreen = (headerText === 'MRAT Classic' || headerText === 'MRAT Admin' || headerText === NONMO_USER_ROLE.User || headerText === NONMO_USER_ROLE.LateEntryUser);
    const isPageAdmin = (headerText === 'MRAT Admin') || currentAppView === 'infoAdmin';
    const isDraftNoticeVisible = selectedRowTags.some(obj => obj?.InDraftState) && draftStatus && currentAppView === 'tagselectionmoscreen';
    const formOffline = displayFormStatus && !isMRATOnline;
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    const HomePageView = currentAppView === 'home' || currentAppView === 'lateEntryHome';
    const isNonmoNoticeVisible = (isNonMoFeatureEnabled || IsLateEntry) && currentAppView === 'tagselectionnonmoscreen';
    const EnvironmentVariable = () => {
        if (process.env.REACT_APP_RELEASE_INFO) {
            return `${process.env.REACT_APP_ENV} | ${process.env.REACT_APP_RELEASE_INFO}`;
        }
        return `${process.env.REACT_APP_ENV}`;
    };
    const draftCreationTime = selectedTag?.CreatedDateUtc;
    const draftTime = draftCreationTime ? Math.max(0, Math.round(selectedTag?.TimeInDraftAllowed - ((new Date() - new Date(draftCreationTime)) / (1000 * 60) + new Date().getTimezoneOffset()))) : draftDuration;
    const marginBottom = footerNoteMoVisible && draftNoteVisible ? '0px' : '27px';
    const marginBottomDraft = footerNoteMoVisible ? '7px' : '22px';
    const getAdminVersion = () => <div>{`V${process.env.REACT_APP_ADMIN_VERSION}`}</div>;

    const getRoleDisplayText = () => adGroupType?.AdGroupTypeId === 2 || adGroupType?.AdGroupTypeId === 4/* Support */ ? `${userRole ?? ''} ${adGroupType.Code}` : userRole ?? '';

    const getLoggedAsText = () => <div>{LOGGED_IN_AS_TEXT + getRoleDisplayText()}</div>;

    const getDraftNoticeText = () => (
        <div style={{ marginBottom: marginBottomDraft }}>
            <span style={{ color: '#ea7c34', fontSize: '12px', fontStyle: 'italic', fontWeight: '550' }}>*Records in orange color are saved as draft</span>
        </div>
    );

    const getMoDraftNoticeText = () => (
        <div style={{ marginBottom: marginBottomDraft }}>
            <span style={{ color: '#ea7c34', fontSize: '12px', fontStyle: 'italic', fontWeight: '550' }}>*MO number in orange color indicates that one or more FLOCs are saved as draft</span>
        </div>
    );

    const getDateNoticeText = () => (
        <div style={{ marginBottom, lineHeight: '8px' }}>
            <span style={{ color: '#ea7c34', fontSize: '12px', fontStyle: 'italic', fontWeight: '550' }}>*Date in red color indicates that the MO has passed its Scheduled Start Date</span>
        </div>
    );

    const getNonMoDataNoticeText = () => (
        <div style={{ marginBottom: '20px', lineHeight: '8px' }}>
            <span style={{ color: '#ea7c34', fontSize: '12px', fontStyle: 'italic', fontWeight: '550' }}>
                {`*Data shown is from the last ${nonMoTagDuration} hours`}
            </span>
        </div>
    );
    const showDraftClock = () => displayFormStatus && (draftButtonVisible || selectedTag?.InDraftState);
    const submitButtonForNonMoUser = () => {
        if (HomePageView) {
            return (
                <SubmitButton openCameraButtonVisible={openCameraButtonVisible} formOffline={formOffline && !MatchSRA(currentAppView)}>
                    {!closeCameraButtonVisible && buttonVisible && entryButtonVisible && (
                        <button type="button" onClick={handleButton} disabled={isDisabled}>
                            {buttonText}
                        </button>
                    )}
                </SubmitButton>
            );
        }
        return (
            <SubmitButton openCameraButtonVisible={openCameraButtonVisible} formOffline={formOffline && !MatchSRA(currentAppView)}>
                {!closeCameraButtonVisible && buttonVisible && (
                    <button type="button" onClick={handleButton} disabled={isDisabled}>
                        {buttonText}
                    </button>
                )}
            </SubmitButton>
        );
    };
    return (
        <div style={{ position: 'relative' }}>
            <FooterContainer
                className="footer"
                widerFooter={widerFooter}
            >
                <GradientLine />
                <Version>
                    <OnlineOfflineIndicator />
                </Version>
                <TrfDropdown>
                    {!closeCameraButtonVisible && trfSelectionVisible && (
                        <TrfDropdownSelection />
                    )}
                </TrfDropdown>
                <OpenCameraButton openCameraButtonVisible={openCameraButtonVisible}>
                    {openCameraButtonVisible && !closeCameraButtonVisible && (
                        <button type="button" onClick={openCameraHandler}>
                            Open Camera
                        </button>
                    )}
                </OpenCameraButton>
                <CloseCameraButton openCameraButtonVisible={openCameraButtonVisible}>
                    {closeCameraButtonVisible && (
                        <button type="button" onClick={closeCameraHandler}>
                            Close Camera
                        </button>
                    )}
                </CloseCameraButton>
                {showDraftClock() && (
                    <div style={{ position: 'absolute', right: '48%', bottom: '22%' }}>
                        <TimerIcon style={{ color: 'var(--primaryRgb)', fontSize: '25px' }} />
                        <span style={{ color: 'var(--primaryRgb)', fontSize: '11px', fontStyle: 'italic', fontWeight: '550' }}>{`${draftTime} min`}</span>
                    </div>
                )}
                {(isNonMoFeatureEnabled || IsLateEntry)
                    && !selectedTrfId
                    && (
                        <ModifyButton openCameraButtonVisible={openCameraButtonVisible} formOffline={formOffline && !MatchSRA(currentAppView)}>
                            {buttonVisible && HomePageView && GetNonMoTrfList && (
                                <button type="button" onClick={modifyButtons}>
                                    Modify TRF
                                </button>
                            )}
                        </ModifyButton>
                    )}
                {isNonMoFeatureEnabled || IsLateEntry
                    ? submitButtonForNonMoUser()
                    : (
                        <SubmitButton openCameraButtonVisible={openCameraButtonVisible} formOffline={formOffline && !MatchSRA(currentAppView)}>
                            {!closeCameraButtonVisible && buttonVisible && (
                                <button type="button" onClick={handleButton} disabled={isDisabled}>
                                    {buttonText}
                                </button>
                            )}
                        </SubmitButton>
                    )}

                <SubmitButton openCameraButtonVisible={openCameraButtonVisible} formOffline={formOffline && !MatchSRA(currentAppView)}>
                    {!closeCameraButtonVisible && draftButtonVisible && (
                        <button type="button" onClick={draftButtonHandler} disabled={isDisabled}>
                            Save As Draft
                        </button>
                    )}
                </SubmitButton>
                <SubmitButton>
                    {printButtonVisible && (
                        <button type="button" onClick={printButtonHandler}>
                            Print
                        </button>
                    )}
                </SubmitButton>
                <FooterContent>
                    <div>
                        {isNonmoNoticeVisible && getNonMoDataNoticeText()}
                        {isDraftNoticeVisible && getDraftNoticeText()}
                        {footerNoteMoVisible && getDateNoticeText()}
                        {draftNoteVisible && getMoDraftNoticeText()}
                        {}
                        {isPageAdmin && getAdminVersion()}
                        {isPageHomeScreen && getLoggedAsText()}
                        <div>
                            Instrumentation and Control Maintenance Recording |
                            {' '}
                            {EnvironmentVariable()}
                        </div>
                    </div>
                </FooterContent>
            </FooterContainer>
        </div>
    );
};

Footer.propTypes = {
    adGroupType: PropTypes.object,
    buttonText: PropTypes.string,
    buttonVisible: PropTypes.any,
    closeCameraButtonVisible: PropTypes.bool,
    closeCameraHandler: PropTypes.func,
    currentAppView: PropTypes.string,
    displayFormStatus: PropTypes.bool,
    draftButtonHandler: PropTypes.func,
    draftButtonVisible: PropTypes.bool,
    draftDuration: PropTypes.number,
    draftNoteVisible: PropTypes.bool,
    draftStatus: PropTypes.bool,
    entryButtonVisible: PropTypes.any,
    footerNoteMoVisible: PropTypes.bool,
    GetNonMoTrfList: PropTypes.bool,
    handleButton: PropTypes.func,
    headerText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isDisabled: PropTypes.bool,
    IsLateEntry: PropTypes.bool,
    isMRATOnline: PropTypes.bool,
    modifyButtons: PropTypes.func,
    nonMoTagDuration: PropTypes.number,
    openCameraButtonVisible: PropTypes.bool,
    openCameraHandler: PropTypes.func,
    printButtonHandler: PropTypes.func,
    printButtonVisible: PropTypes.any,
    selectedRowTags: PropTypes.array,
    selectedTag: PropTypes.object,
    selectedTrfId: PropTypes.string,
    trfSelectionVisible: PropTypes.bool,
    userRole: PropTypes.string,
    widerFooter: PropTypes.string
};

const mapStateToProps = ({ Home, AppData, TagSelectionMOScreen, Forms }) => ({
    userRole: Home.userRole,
    adGroupType: Home.adGroupType,
    isMRATOnline: AppData.isMRATOnline,
    currentAppView: Home.currentView,
    draftStatus: Home.draftStatus,
    selectedRowTags: TagSelectionMOScreen.selectedRowTags,
    selectedTag: Forms.selectedTag,
    draftDuration: Home.draftDuration,
    selectedTrfId: Forms.selectedTrfId,
    nonMoTagDuration: TagSelectionMOScreen.nonMoTagDuration,
    GetNonMoTrfList: Home.GetNonMoTrfList,
    IsLateEntry: Home.IsLateEntry

});

const mapDispatchToProps = dispatch => ({
    dispatch
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Footer);
